import { useState } from 'react';
import QuizCardLoading from './QuizCardLoading';
import { cn } from '@/helpers/cn';
import { LockMatchIcon, MatchTickIcon } from '@/assets/Icons';

function QuizzesBodyItem({ item, onClick }) {
    const { background_image, altText, is_active, id, media_object } = item;

    const [imageLoading, setImageLoading] = useState(true);

    const isActive = is_active || media_object?.is_active;
    const isParticipated = !!item.participation;

    return (
        <div className="quizzes-body-item" onClick={onClick} id={id}>
            <QuizCardLoading isImageLoading={imageLoading}>
                <img
                    className={cn('-z-10', {
                        absolute: imageLoading,
                        grayscale: isParticipated
                    })}
                    onLoad={() => setImageLoading(false)}
                    alt={altText || ''}
                    src={background_image || media_object?.background_image}
                />
            </QuizCardLoading>
            {isParticipated && (
                <div className="absolute top-4 left-4 p-1.5 text-xs font-bold flex rounded-md items-center gap-1 bg-white shadow-[0px_1.2px_2.4px_0px_rgba(0,_0,_0,_0.20)]">
                    <MatchTickIcon />
                    <span className="done-text">انجام شده</span>
                </div>
            )}
            {!isActive && !isParticipated && (
                <>
                    <div className="absolute w-full h-full top-0 left-0 right-0 bottom-0 bg-[linear-gradient(180deg,_rgba(52,_54,_56,_0.00)_0%,_rgba(52,_54,_56,_0.36)_50.5%,_rgba(52,_54,_56,_0.70)_100%)] rounded-2xl" />
                    <LockMatchIcon className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                </>
            )}
        </div>
    );
}

export default QuizzesBodyItem;
